// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1bSWh","notes":"Notes_notes__T_OAP","note":"Notes_note__3lKz4","markdown":"Notes_markdown__sjceu"};